import { getDeliveryByEventName } from '@noths/polaris-client-utils';
import * as R from 'ramda';

import { ARRIVES_BY } from 'src/components/molecules/ProductCard/constants/copy';

export const getDeliveryByEventLabel = R.compose(
  R.ifElse(R.isNil, R.always(''), R.concat(ARRIVES_BY)),
  getDeliveryByEventName,
);
